import { KeyboardArrowDown } from "@mui/icons-material";

import AutoCompleteDropdown from "../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import HNSColors from "../../../../ui library/HNSColors";
import { CONTRACTS_MODAL_STYLES } from "../../styles/styles";


export default function ContractsSingleSelectDropdown({
  placeholder = "",
  fieldName,
  fieldValue,
  onChange,
  data = [],
}) {
  const selectedOption = data.find((option) => option.id === fieldValue) ?? null;

  return (
    <AutoCompleteDropdown
      data={data}
      initValue={selectedOption}
      getOptionLabel={(option) => option?.label || ""}
      isOptionEqualToValue={(option, optionValue) =>
        option?.id === optionValue?.id || option === optionValue
      }
      renderTags={null}
      placeholder={placeholder}
      onValueChange={(_, value) => {
        onChange(fieldName, value?.id ?? null);
      }}
      ListboxProps={{
        sx: {
          maxHeight: 200,
          overflow: "auto",
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: HNSColors.primary[500],
            borderRadius: "3px",
          },
        },
      }}
      textFieldSx={CONTRACTS_MODAL_STYLES.textField}
      selectProps={{
        IconComponent: (props) => (
          <KeyboardArrowDown
            {...props}
            sx={{ fontSize: 24, color: HNSColors.primary[500] }}
          />
        ),
      }}
      dropdownSx={CONTRACTS_MODAL_STYLES.dropdownPaper}
      disableClearable={true}
    />
  );
}
